import { render, staticRenderFns } from "./CMContactsImport.vue?vue&type=template&id=2022724a&scoped=true&"
import script from "./CMContactsImport.vue?vue&type=script&lang=js&"
export * from "./CMContactsImport.vue?vue&type=script&lang=js&"
import style0 from "./CMContactsImport.vue?vue&type=style&index=0&id=2022724a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022724a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2022724a')) {
      api.createRecord('2022724a', component.options)
    } else {
      api.reload('2022724a', component.options)
    }
    module.hot.accept("./CMContactsImport.vue?vue&type=template&id=2022724a&scoped=true&", function () {
      api.rerender('2022724a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/CMContactsImport.vue"
export default component.exports